import { render } from "./RFQDetail.vue?vue&type=template&id=5a707815"
import script from "./RFQDetail.vue?vue&type=script&lang=js"
export * from "./RFQDetail.vue?vue&type=script&lang=js"

import "./RFQDetail.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script